// extracted by mini-css-extract-plugin
export default {"AddYyModal":"index_AddYyModal__pCSrn"};